/** @format */
import useSortableColumns from '@common/application/hooks/useSortableColumns/useSortableColumns';

const useColumnSorting = (sortConfig?: { columnId?: string; ascending?: boolean }) => {
  const sortMap = useSortableColumns();

  if (!sortConfig?.columnId) {
    return {};
  }

  const columnKey = sortMap[sortConfig.columnId] ?? sortConfig.columnId;
  return { [columnKey]: sortConfig.ascending ? 'asc' : 'desc' };
};

export default useColumnSorting;
